import { FILE_ICONS } from "@/features/my-files/assets/file-icons";

interface FileTypeIconProps {
  extension: string;
  mime?: string;
}

export function FileTypeIcon({ extension, mime }: FileTypeIconProps) {
  const normalizedExtension = (() => {
    const ext = extension.toLowerCase();

    if (ext === "jpeg" || mime === "image/jpeg") {
      return "jpg";
    }

    return ext;
  })();

  const IconComponent =
    normalizedExtension in FILE_ICONS
      ? FILE_ICONS[normalizedExtension as keyof typeof FILE_ICONS]
      : FILE_ICONS.fallback;

  return <IconComponent className="size-xl shrink-0" />;
}
